import App from './App.vue'
import router from './router'
import store from './stores'
import directives from '@/directives'

import '@x7web/tcom-ui/es/style.css'
import '@assets/css/reset/index.css'

import { getIsInternational } from '@/utils/internationality'

window.isInternational = getIsInternational()

window.isInternational && (document.title = 'x7game Developer')

createApp(App).use(router).use(directives).use(store).mount('#app')
